import React from 'react';
import { observer } from "mobx-react-lite";
import { BooleanActionDetail } from "./components/BooleanActionDetail";
import { undoableSetDebugStartNodeOp } from '../../../stores/undo/operation/ActionEditorDebugStartNodeChangeOp';
import { gameStore } from '../../../stores/GameStore';
import { useTranslation } from 'react-i18next';
export const DebugStartActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_debug_start"),
    checked: gameStore.debugStartNodeModelId === (action === null || action === void 0 ? void 0 : action.$modelId),
    toggle: () => undoableSetDebugStartNodeOp(action)
  }), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_debug_initialize"),
    checked: action.initialize,
    toggle: action.toggleInitialize.bind(action)
  }));
});